import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as GrIcons from "react-icons/gr";
import { useWizard } from "react-use-wizard";
import { makeGetRequest } from "../../../services/apiHandler";
import { stepActions } from "../../../store/Steps";
import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "../../../store/UserProfileData";
import { variants } from "../../../shared/variants";
import { useMixpanel } from "react-mixpanel-browser";
import { useTranslation } from "react-i18next";

function InsurerDetails({ setCurrentScreen }: any) {
  const { t } = useTranslation();
  const profileSelector = useSelector((state: any) => state.profile.profile);
  const mixpanel = useMixpanel()
  const { previousStep, goToStep } = useWizard();
  const [userInfo, setUserInfo] = useState({
    email: profileSelector?.email ? profileSelector?.email : "",
    userName: profileSelector?.name ? profileSelector?.name : "",
    phoneNumber: profileSelector?.phone ? profileSelector?.phone : "",
    postaladdress: profileSelector?.postaladdress
      ? profileSelector?.postaladdress
      : "",
    postalcode: profileSelector?.postalcode ? profileSelector?.postalcode : "",
    gender: profileSelector?.gender ? profileSelector?.gender : "",
  });
  const dispatch = useDispatch();
  const SKEY = sessionStorage.getItem("SKEY") || "";

  const saveDetails = () => {
    if (!userInfo.userName) {
      toast.warning(t("insurerDetails.enterName"));
      document.getElementById("userName")?.focus();
      return;
    }

    let pattern =
      /^(?=.{3,})([A-Za-z']{3,}\s+){1,2}([A-Za-z']+\s+)*[A-Za-z']+\s*$/;
    if (!pattern.test(userInfo.userName)) {
      toast.warning(t("insurerDetails.enterTwoNames"));
      document.getElementById("userName")?.focus();
      return;
    }
    const validateEmail = (email: string) => {
      let emailPattern =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          email
        );
      return emailPattern;
    };
    if (!validateEmail(userInfo.email)) {
      toast.warning(t("insurerDetails.enterValidEmail"));
      document.getElementById("email")?.focus();
      return;
    }
  
    if (!userInfo.gender) {
      toast.warning(t("insurerDetails.selectGender"));
      document.getElementById("gender")?.focus();
      return;
    }
    const onValidatePhoneNumber = (phoneNumber: any) => {
      const regex = /^(\+254|0)[1-9]\d{8}$/.test(phoneNumber);
      return regex;
    };
    if (!onValidatePhoneNumber(userInfo.phoneNumber)) {
      toast.warning(t("insurerDetails.enterValidPhone"));
      document.getElementById("phoneNumber")?.focus();
      return;
    }

    let userPrfile = {
      ...profileSelector,
      name: userInfo?.userName,
      email: userInfo?.email,
      phone: userInfo?.phoneNumber,
      gender: userInfo?.gender,
    };

    sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    sessionStorage.setItem("docs-current-screen", "insurer-docs");
    dispatch(profileActions.setUserProfile(userPrfile));
    setCurrentScreen("insurer-docs");
  };

  const handleInputChange = (event: any) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    setUserInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const getSasToken = async () => {
    const result: IApiResponse = await makeGetRequest(
      `${process.env.REACT_APP_CORE_API_URL}/getSASkey`,
      {
        SKEY: SKEY,
      }
    );

    if (result.Status === 200) {
      sessionStorage.setItem("sasToken", result.Payload);
      sessionStorage.setItem("tokenValid", "true");
    }

    if (result.Status === 543) {
      toast.error(t("insurerDetails.sessionExpired"));
      sessionStorage.setItem("tokenValid", "false");
      goToStep(3);
    }

    if (result.Status === 401) {
      toast.error(t("insurerDetails.invalidToken"));
      sessionStorage.setItem("tokenValid", "false");
      goToStep(3);
    }
  };

  useEffect(() => {
    if (mixpanel.config.token) {
      mixpanel.track("PageView", {
        pageName: "Travel|Insurer-details",
      });
    }
    getSasToken();
  }, [mixpanel]);

  return (
    <div className="container">
      <motion.div
        variants={variants}
        initial="enter"
        animate="center"
        exit={{ opacity: 0 }}
      >
        <div className="ky-inputs-container ky-inputs-container-insurer">
          <div className="reg-title text-left">
            {t("insurerDetails.letsGet")}<span className="span-title">{t("insurerDetails.covered")}</span>
          </div>
          <br />
          <div className="row d-flex justify-content-between-align-items-center">
            <div className="col-md-4">
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="userName">
                    {t("insurerDetails.fullName")}
                  </label>
                  <br />
                  <input
                    id="userName"
                    name="userName"
                    type="text"
                    onChange={handleInputChange}
                    value={userInfo.userName}
                    placeholder={t("insurerDetails.typeHere")}
                  ></input>
                </motion.div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="email">
                    {t("insurerDetails.emailAddress")}
                  </label>
                  <br />
                  <input
                    id="email"
                    name="email"
                    type="email"
                    onChange={handleInputChange}
                    value={userInfo.email}
                    placeholder={t("insurerDetails.typeEmail")}
                  ></input>
                </motion.div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="gender">
                    {t("insurerDetails.gender")}
                  </label>
                  <br />
                  <div className="ky-input-wrapper-type">
                    <div className="male d-flex justify-content-start me-5">
                      <input
                        id="gender"
                        name="gender"
                        type="radio"
                        onChange={handleInputChange}
                        value="male"
                        placeholder="Type location"
                      ></input>
                      <label className="ms-2">{t("insurerDetails.male")}</label>
                    </div>
                    <div className="female d-flex justify-content-start align-items-center">
                      <input
                        id="gender"
                        name="gender"
                        type="radio"
                        onChange={handleInputChange}
                        value="female"
                        placeholder="Type location"
                      ></input>
                      <label className="ms-2">{t("insurerDetails.female")}</label>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
          <div className="row d-flex justify-content-between-align-items-center mt-2">
            <div className="col-md-4">
              <div className="ky-input-wrapper">
                <motion.div
                  animate={{ scale: [-0.7, 1] }}
                  transition={{ duration: 1 }}
                  className="ky-input-container mt-4"
                >
                  <label className="text-left-label mb-2" htmlFor="phoneNumber">
                    {t("insurerDetails.phoneNumber")}
                  </label>
                  <br />
                  <input
                    id="phoneNumber"
                    name="phoneNumber"
                    type="text"
                    onChange={handleInputChange}
                    value={userInfo.phoneNumber}
                    placeholder={t("insurerDetails.typePhone")}
                  ></input>
                </motion.div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-5">
            <div className="previous">
              <span
                onClick={(e) => {
                  if (dispatch(stepActions.onRemoveStep())) {
                    previousStep();
                  }
                }}
              >
                <span className="GrIcon me-2">
                  <GrIcons.GrFormPreviousLink />
                </span>{" "}
                <span className="previous">{t("insurerDetails.previous")}</span>
              </span>
            </div>
            <div onClick={() => saveDetails()}>
              <button className="next-btn">{t("insurerDetails.proceed")}</button>
            </div>
          </div>
        </div>
        <br />
        <br />
      </motion.div>
    </div>
  );
}

export default InsurerDetails;
